import { useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import PlanningService from "../Services/PlanningService";
import nlBE from "date-fns/locale/nl-BE";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import { Button } from "reactstrap";
import { useMsal } from "@azure/msal-react";
import GraphService from "../Services/GraphService";
import FuturePlanningForSupplier from "../Models/FuturePlanningForSupplier";
import Checkbox from "../Components/Checkbox";

const PlanningOverviewSuppliers = () => {
  const { instance } = useMsal();

  const planningService = useMemo(
    () => new PlanningService(instance),
    [instance]
  );
  const graphService = useMemo(() => new GraphService(instance), [instance]);

  const [planningOverview, setPlanningOverview] = useState<
    FuturePlanningForSupplier[]
  >([]);

  const [checkedIdList, setCheckedIdList] = useState<number[]>([]);

  registerLocale("nlBE", nlBE);

  useEffect(() => {
    async function loadData() {
      try {
        const data = await planningService.getOverviewSuppliers();
        setPlanningOverview(data);
        //setCheckedIdList(data.map((r) => r.id));
      } catch (error) {
        toast.error("Fout bij het ophalen van de data.");
      }
    }

    loadData();
  }, [planningService]);

  async function mailSuppliers() {
    try {
      const user = await graphService.getUserDetails();
      await planningService.mailSuppliers(
        user.mail ?? user.userPrincipalName ?? "",
        planningOverview.filter((r) => checkedIdList.includes(r.id))
      );

      toast.success("Mails verzonden.");
    } catch (error) {
      toast.error("Fout bij het versturen van de email.");
    }
  }

  let actions = (
    <div className="card mb-3">
      <div className="card-body">
        <form>
          <div className="row">
            <div className="col-2">
              <Button color="primary" onClick={mailSuppliers}>
                Mail toekomstige planning naar OA
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );

  const supplierCodes = planningOverview
    .map((rec) => rec.supplierCode)
    .filter((value, index, self) => self.indexOf(value) === index);

  return (
    <div className="container-fluid">
      {actions}
      <div className="card mb-3">
        <div className="card-body">
          {supplierCodes.map((supCode, index) => {
            let comments = planningOverview.find(
              (r) => r.supplierCode === supCode
            )?.comments;

            return (
              <span key={index}>
                {
                  planningOverview.find((r) => r.supplierCode === supCode)
                    ?.supplierName
                }
                <br />
                {planningOverview
                  .filter((r) => r.supplierCode === supCode)
                  .map((rec, index) => (
                    <div key={index} className=" row">
                      <div className="col-1">
                        <Checkbox
                          className=""
                          label=""
                          value={rec.id.toString()}
                          checked={
                            checkedIdList.find((r) => r === rec.id) !==
                            undefined
                          }
                          onChange={(event: any) => {
                            if (event.target.checked) {
                              setCheckedIdList((old) => [...old, rec.id]);
                            } else {
                              //const idIndex = checkedIdList.indexOf(rec.id);
                              setCheckedIdList((old) =>
                                old.filter((r) => r !== rec.id)
                              );
                            }
                          }}
                        />
                      </div>
                      <div className="col-1">{rec.projectCode}</div>
                      <div className="col-4">
                        <input
                          type="text"
                          className="form-control"
                          onChange={(event) =>
                            setPlanningOverview((old) => {
                              const clonedRecIndex = old.findIndex(
                                (r) => r.id === rec.id
                              );
                              const clonedRec = { ...old[clonedRecIndex] };
                              clonedRec.projectName = event.target.value;

                              const clonedState = [...old];
                              clonedState[clonedRecIndex] = clonedRec;
                              return clonedState;
                            })
                          }
                          value={rec.projectName}
                        />
                      </div>
                      <div className="col-1">{rec.actualStartDate}</div>
                    </div>
                  ))}
                <br />
                <textarea
                  className="form-control "
                  title="Opmerkingen"
                  style={{ height: "60px" }}
                  value={comments}
                  onChange={(e) =>
                    setPlanningOverview((old) => {
                      const clonedRecIndex = old.findIndex(
                        (r) => r.supplierCode === supCode
                      );
                      const clonedRec = { ...old[clonedRecIndex] };
                      clonedRec.comments = e.target.value;

                      const clonedState = [...old];
                      clonedState[clonedRecIndex] = clonedRec;
                      return clonedState;
                    })
                  }
                ></textarea>
                <br />
              </span>
            );
          })}
          {/* {planningOverview.split("\n").map((str, index) => (
            <span key={index}>
              {str}
              <br />
            </span>
          ))} */}
        </div>
      </div>
    </div>
  );
};

export default PlanningOverviewSuppliers;
